import { jsonFetch } from "@/lib/helpers";
import { Bookings } from "@/models/booking";
import { BOOKINGS_URL } from "./api-url.constants";
import { BookingsDTO } from "./dtos";
import { mapBookingsDTOtoBookings } from "./mappers";

export const getBookings = async (queryParams: string): Promise<Bookings> => {
  const paginatedBookingsDTO = await jsonFetch<BookingsDTO>(`${BOOKINGS_URL}${queryParams}`);
  return mapBookingsDTOtoBookings(paginatedBookingsDTO.data);
};
